<template>
    <div>

        <!-- mission group tqTabs-->
        <component :is="co_showGroupMissions_b ? TqTabs : 'div'"
                   :key="tqTabs_selectedTabIndex_missionsGroup_vn.val"

                   :p_selected-tab-index_vn="tqTabs_selectedTabIndex_missionsGroup_vn"
                   p_att_s="qbmg_name_byLangCode_s"
                   :p_system_lang-code_e="p_system_langCode"
                   :p_display_lang-code_e="p_qb_displayLangCode_e"
                   :p_tabs_ao="p_qb_missionsGroups_ac"

                   :p_vertical-layout_b="true"
                   p_tabs-class_s="TQ_padding_8px_16px"
                   class="TQ_padding_4px"

                   :p_title_blc_s="ass_strings.twoWords_MissionsGroups"

                   :p_delete-tab_approve-text_cla_s="ass_strings.question_deleteGroup"
                   :pe_delete-tab_click_f="m_missionGroup_remove_f"

                   :pe_on-change-order_f="pe_reorderMissionsGroups_f"

                   :p_add-tab-text_s="ass_strings.twoWords_newGroup[p_system_langCode]"
                   :pe_add-tab_click_f="m_missionGroup_add_f">

            <!-- edit mission group -->
            <div v-if="co_showGroupMissions_b && co_selectedMissionsGroup_c"
                 class="TQ_bg_gray4 TQ_padding_8px TQ_margin_0_4px">

                <div v-if="co_showPointsToUnlock_b" class="TQ_margin_8px">
                    <div class="TQ_text_bold"> {{ass_strings.fourWords_pointsToUnlockLevel[p_system_langCode]}}</div>
                    <input type="number"
                           v-model.number="co_selectedMissionsGroup_c.qbmg_pointsToUnlock_n"
                           :placeholder="ass_strings.oneWord_points[p_system_langCode]"
                           class="TQ_center TQ_padding_4px TQ_margin_4px TQ_text_20px"/>
                </div>

                <div class="TQ_bg_white TQ_inline">

                    <!-- by lang code -->
                    <div class="TQ_inline TQ_maxWidth_320px TQ_margin_8px"
                         :style="{'direction' : helper_getDirectionByLangCode_fe(langCode)}"
                         :key="langCode"
                         v-for="(langCode, langIndex) in p_qb_supportedLangCodes_ae">

                        <!-- lang title-->
                        <div class="TQ_text_24px"> {{format_langCode_fs(langCode)}}</div>

                        <input class="TQ_input TQ_text_20px" v-model="co_selectedMissionsGroup_c.qbmg_name_byLangCode_s[langCode]"/>
                    </div>



                    <div >
                        <tq-image :pb_src_r="co_selectedMissionsGroup_c.qbmg_imgFile_c.fi_url_s"
                                  class="TQ_width_200px TQ_border TQ_center"/>
                    </div>


                    <!--<div><img :src="co_selectedMissionsGroup_c.qbmg_imgFile_c.fi_url_s" class="TQ_width_200px TQ_border"/></div>-->

                    <div class="TQ_btn TQ_bg_gray4 TQ_margin_bottom_8px TQ_text_bold" @click="m_missionGroup_setImage_f">
                        {{ass_strings.twoWords_changeFile[p_system_langCode]}}
                    </div>

                </div>

            </div>

            <!-- mission tqTabs-->
            <tq-tabs v-if="co_display_qb_missions_ac != null"
                     class="TQ_padding_4px"

                     :p_selected-tab-index_vn="tqTabs_selectedTabIndex_mission_vn"
                     p_att_s="qbr_title_blc_s"
                     :p_system_lang-code_e="p_system_langCode"
                     :p_display_lang-code_e="p_qb_displayLangCode_e"
                     :p_tabs_ao="co_display_qb_missions_ac"

                     :p_vertical-layout_b="true"
                     p_tabs-class_s="TQ_padding_8px_16px"

                     :p_title_blc_s="ass_strings.oneWord_missions"

                     :p_delete-tab_approve-text_cla_s="ass_strings.question_deleteMission"
                     :pe_delete-tab_click_f="m_mission_remove_f"

                     :p_add-tab-text_s="ass_strings.twoWords_newMission[p_system_langCode]"
                     :pe_add-tab_click_f="m_mission_add_f"

                     :pe_on-change-order_f="(qb_mission_newOrder_ac) => {pe_reorderMissions_f(qb_mission_newOrder_ac, co_selectedMissionsGroup_c ? co_selectedMissionsGroup_c.qbmg_missionsGroupId_n: null)}">

                <!-- edit mission -->
                <div v-if="co_getCurrentMission_c != null" class="TQ_minHeight_400px">

                    <tq-riddle-data_-edit
                            :key="co_getCurrentMission_c.qbr_riddleId_n"
                            :uid="'missionRiddle' + '_' + co_getCurrentMission_c.qbr_riddleId_n"

                            :p_qb_riddle_c="co_getCurrentMission_c"
                            :lang-arr="p_qb_supportedLangCodes_ae"

                            :p_metadata-q-b_c="p_qb_metadata_c"
                            :p_system_lang-code_e="p_system_langCode"
                            :p_qb_displayLangCode_e="p_qb_displayLangCode_e"
                            :p_creator-active-payment-plan_b="p_creatorActivePaymentPlan_b"


                            :p_show-edit-image_b="true"
                            :p_show-edit-subtitle_b="true"
                            :pe_choose-file_f="pe_chooseFile_f"
                    />

                </div>

            </tq-tabs>

        </component>

    </div>
</template>

<script>

    import TqSelectImage from '../../../../components/mediaComponenets/TqSelectImage'
    import WysiwygEditor from "../../../../components/complex/TqWysiwygEditor";
    import { enum_langCodes} from "../../../../../functions/src/shareCode/Share_S_Enum";
    import TqCard from "../../../../components/basic/TqCard";
    import {validator_enum_array_fb} from "../../../../../functions/src/shareCode/Share_S_Validator";
    import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import TqDropdown from "../../../../components/basic/TqDropdown";
    import TqPopup from "../../../../components/basic/TqPopup";
    import {format_langCode_fs} from "../../../../../functions/src/shareCode/Share_S_Format";
    import {notification_notify} from "../../../../scripts/S_Notification";
    import {
        helper_getDirectionByLangCode_fe,
        helper_getRiddleIndexWithRiddleId_fn,
        helper_getRiddleWithRiddleId_fc
    } from "../../../../scripts/S_Helper";
    import TqTabs from "../../../../components/basic/TqTabs";
    import {validator_arrayClass_fb, validator_enum_fb} from "../../../../../functions/src/shareCode/Share_S_Validator";
    import TqImage from "../../../../components/basic/TqImage";
    import {
        FB_QuestBody_Metadata,
        FB_QuestBody_MissionsGroup,
        FB_QuestBody_Riddle
    } from "../../../../../functions/src/shareCode/Share_S_Classes";
    import TqRiddleData_Edit from "@/components/complex/TqRiddleData_Edit";

    export default {
        name: "C_Creator_EditQuest_Item_MissionsGroups",
        components:{
            TqRiddleData_Edit,
            TqImage,
            TqTabs,
            TqPopup,
            TqDropdown,
            TqCard,
            WysiwygEditor,
            TqSelectImage
        },
        props:{
            p_qb_sideMissions_ac:{
                type:Array,
                require:true,
                validator(arr){
                    return validator_arrayClass_fb(arr, FB_QuestBody_Riddle)
                }
            },
            p_qb_missionsGroups_ac:{
                type:Array,
                require:true,
                validator(arr){
                    return validator_arrayClass_fb(arr, FB_QuestBody_MissionsGroup)
                }
            },
            p_qb_metadata_c:{
                type:FB_QuestBody_Metadata,
                require:true,
            },

            // langCodes
            p_system_langCode:{
                require: true,
                type: String,
                validator(val) {
                    return validator_enum_fb(enum_langCodes, val)
                }
            },
            p_qb_displayLangCode_e:{
                require:true,
                type:String,
                validator(val) {
                    return validator_enum_fb(enum_langCodes, val)
                }
            },
            p_qb_supportedLangCodes_ae:{
                type: Array,
                require: true,
                validator(arr){
                    return validator_enum_array_fb(enum_langCodes ,arr)
                }
            },

            // functions
            pe_addMissionRiddle_f:{
                require: true,
                type: Function,
            },
            pe_addMissionGroup_f:{
                require: true,
                type: Function,
            },
            pe_reorderMissions_f:{
                require: true,
                type: Function,
            },
            pe_reorderMissionsGroups_f:{
                require: true,
                type: Function,
            },
            p_creatorActivePaymentPlan_b:{
                type: Boolean,
                require: true
            },
            pe_chooseFile_f: {},
        },
        data(){
            return{
                getFile_vf                              : {val : () => {}},
                tqTabs_selectedTabIndex_mission_vn      : {val : null},
                tqTabs_selectedTabIndex_missionsGroup_vn      : {val : null},

                // ======= imports ===========
                TqTabs                          : TqTabs,
                ass_strings                     : ass_strings,
                format_langCode_fs              : format_langCode_fs,
                helper_getRiddleAttRiddleId_fc  : helper_getRiddleWithRiddleId_fc,
                helper_getDirectionByLangCode_fe: helper_getDirectionByLangCode_fe,
            }
        },
        computed : {
            co_showGroupMissions_b(){
                return this.p_qb_metadata_c.qbm_listMissions_supportMissionsGroups_b
            },
            co_showPointsToUnlock_b(){
                return this.p_qb_metadata_c.qbm_listMissions_supportMissionsGroupsLevels_b
            },
            co_display_qb_missions_ac (){
                // check support missionsGroups
                if(!this.co_showGroupMissions_b){
                    return  this.p_qb_sideMissions_ac
                }

                // check choose mission group
                if(this.tqTabs_selectedTabIndex_missionsGroup_vn.val == null){
                    return null
                }

                // check if val > array.length
                if(this.tqTabs_selectedTabIndex_missionsGroup_vn.val >= this.p_qb_missionsGroups_ac.length){
                    return null
                }

                // return selected missionsGroup missions
                let riddle_ac = []
                this.p_qb_missionsGroups_ac[this.tqTabs_selectedTabIndex_missionsGroup_vn.val].qbmg_riddlesIds_an
                    .forEach(riddleId_n =>{
                        let questBody_riddle_c = helper_getRiddleWithRiddleId_fc(this.p_qb_sideMissions_ac, riddleId_n)
                        if(questBody_riddle_c != null){
                            riddle_ac.push(questBody_riddle_c)
                        }
                    });

                return riddle_ac

            },
            co_getCurrentMission_c() {

                if(this.tqTabs_selectedTabIndex_mission_vn.val == null){
                    return null
                }

                if(!this.co_showGroupMissions_b){
                    return this.p_qb_sideMissions_ac[this.tqTabs_selectedTabIndex_mission_vn.val]

                }else{
                    // support missionsGroups
                    if(this.co_display_qb_missions_ac[this.tqTabs_selectedTabIndex_mission_vn.val] == null){
                        return null
                    }

                    let riddleId_n = this.co_display_qb_missions_ac[this.tqTabs_selectedTabIndex_mission_vn.val].qbr_riddleId_n
                    let missionIndex_n = helper_getRiddleIndexWithRiddleId_fn(this.p_qb_sideMissions_ac, riddleId_n)
                    return this.p_qb_sideMissions_ac[missionIndex_n]
                }

            },
            co_selectedMissionsGroup_c(){
                return this.p_qb_missionsGroups_ac[this.tqTabs_selectedTabIndex_missionsGroup_vn.val]
            },
            co_firstValue_tqTabs_selectedIndex_groupMissions_n(){

                if(this.p_qb_missionsGroups_ac.length > 0){
                    return 1
                }
                return null
            }
        },
        methods:{

            // missions
            m_mission_remove_f(tabIndex_n){

                if(!this.co_showGroupMissions_b){
                    this.p_qb_sideMissions_ac.splice(tabIndex_n,1)
                }else{


                    let riddleId_n = this.co_display_qb_missions_ac[tabIndex_n].qbr_riddleId_n
                    let missionIndex_n = helper_getRiddleIndexWithRiddleId_fn(this.p_qb_sideMissions_ac, riddleId_n)

                    // remove from missions
                    this.p_qb_sideMissions_ac.splice(missionIndex_n,1)

                    // remove from mission group
                    this.p_qb_missionsGroups_ac[this.tqTabs_selectedTabIndex_missionsGroup_vn.val].qbmg_riddlesIds_an.splice(tabIndex_n,1)

                }
            },
            m_mission_add_f(){

                let newIndex = 0;
                if(!this.co_showGroupMissions_b){
                    this.pe_addMissionRiddle_f(null)
                    newIndex = this.p_qb_sideMissions_ac.length -1
                }else{
                    let qbmg_missionsGroupId_n = this.p_qb_missionsGroups_ac[this.tqTabs_selectedTabIndex_missionsGroup_vn.val].qbmg_missionsGroupId_n
                    this.pe_addMissionRiddle_f(qbmg_missionsGroupId_n)

                    newIndex = this.p_qb_missionsGroups_ac[this.tqTabs_selectedTabIndex_missionsGroup_vn.val].qbmg_riddlesIds_an.length - 1
                }
                this.tqTabs_selectedTabIndex_mission_vn.val = newIndex

            },

            // missions groups
            m_missionGroup_add_f(){
                this.pe_addMissionGroup_f()

                this.tqTabs_selectedTabIndex_missionsGroup_vn.val = this.p_qb_missionsGroups_ac.length - 1
            },
            m_missionGroup_remove_f(missionsGroup_n){
                if(this.p_qb_missionsGroups_ac[missionsGroup_n].qbmg_riddlesIds_an.length > 0 ){
                    notification_notify(ass_strings.oneWord_error, ass_strings.sentence_mustDeleteAllMissions)
                }else{
                    this.p_qb_missionsGroups_ac.splice(missionsGroup_n, 1)
                }
            },
            m_missionGroup_setImage_f(){

                this.pe_chooseFile_f( (newFile_c) =>{
                    this.co_selectedMissionsGroup_c.qbmg_imgFile_c = newFile_c
                })
            },

        },
        mounted(){


            if(this.p_qb_missionsGroups_ac.length > 0){
                this.tqTabs_selectedTabIndex_missionsGroup_vn.val = 0;
            }

            if(this.p_qb_sideMissions_ac.length > 0){
                this.tqTabs_selectedTabIndex_mission_vn.val = 0;
            }
        }
    }
</script>

<style scoped lang="scss">







</style>
